import { jsx } from 'react/jsx-runtime';
import { useLinearLocale } from '../locale/LocaleContext.mjs';
import { Typography } from '../typography/Typography.mjs';
import { localeValues } from './constants/localeValues.mjs';
import { rootStyle } from './search-empty.vanilla.mjs';

function SearchEmptyImpl() {
  const { locale } = useLinearLocale();
  return /* @__PURE__ */ jsx("div", { className: rootStyle, children: /* @__PURE__ */ jsx(Typography, { color: "grayLight", children: localeValues[locale].emptyText }) });
}

export { SearchEmptyImpl as default };
//# sourceMappingURL=SearchEmptyImpl.mjs.map
